import type { CarState } from "../types";

function ago(ms: number | null): string {
  if (!ms) return "—";
  const s = Math.max(0, Math.round((Date.now() - ms) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.round(s / 60)}m ago`;
  return `${Math.round(s / 3600)}h ago`;
}

function Tile({ label, value, tone }: { label: string; value: string; tone?: "ok" | "warn" | "err" | "idle" }) {
  return (
    <div className={`tile tone-${tone ?? "idle"}`}>
      <span className="tile-label">{label}</span>
      <span className="tile-value">{value}</span>
    </div>
  );
}

export default function StatusBar({ s }: { s: CarState }) {
  const batt = s.battV;
  const battTone = batt < 11.8 ? "err" : batt < 12.2 ? "warn" : "ok";
  return (
    <div className="status-grid">
      <Tile label="Link" value={s.online ? "ONLINE" : "OFFLINE"} tone={s.online ? "ok" : "err"} />
      <Tile label="Battery" value={`${batt.toFixed(1)} V`} tone={battTone} />
      <Tile label="Doors" value={s.locked ? "LOCKED" : "UNLOCKED"} tone={s.locked ? "ok" : "warn"} />
      <Tile label="Ignition" value={s.engineRunning ? "ENGINE" : s.ignition ? "ACC" : "OFF"} tone={s.engineRunning ? "ok" : "idle"} />
      <Tile label="Cabin" value={`${Math.round(s.cabinC)}°C`} tone={s.cabinC > 38 ? "warn" : "idle"} />
      <Tile label="Kill" value={s.killArmed ? "ARMED" : "OFF"} tone={s.killArmed ? "err" : "idle"} />
      <Tile label="Last seen" value={ago(s.lastSeen)} tone="idle" />
      <Tile label="Reserve" value={s.reserveArmed ? "ARMED" : "—"} tone={s.reserveArmed ? "warn" : "idle"} />
    </div>
  );
}
